import { View, YStack } from 'smoothie';

import { useAuthedUser } from '../../../common/providers/AuthedUserProvider';
import { getNonTerminatedCardsForUser } from '../../../common/utils/cardUtils';
import { type BankAccountDisplayDetail } from '../../types/BankAccount';
import { CardForm } from '../../types/Card';
import { FruitfulCardIcon } from './FruitfulCard';

const CardStack = ({ account }: { account: BankAccountDisplayDetail }) => {
    const user = useAuthedUser();
    const cards = getNonTerminatedCardsForUser(
        user.syncteraPersonId,
        account.cards,
    );

    const physicalCard = cards?.find((card) => card.form === CardForm.PHYSICAL);
    const virtualCard = cards?.find((card) => card.form === CardForm.VIRTUAL);

    /* FruitfulCardIcon defaults */
    const SINGLE_WIDTH = 48;
    const SINGLE_HEIGHT = 32;
    const STACK_OVERLAP = 20;
    /**
     * Vertical overlap applied to the second card in the stack
     * Shrink both cards so the stack total height equals a single default card:
     *      stacked height = 2 * H - STACK_OVERLAP = SINGLE_HEIGHT
     *      H = (SINGLE_HEIGHT + STACK_OVERLAP) / 2 = 26
     */
    const STACKED_HEIGHT = (SINGLE_HEIGHT + STACK_OVERLAP) / 2;
    const STACKED_WIDTH = Math.round(
        (STACKED_HEIGHT / SINGLE_HEIGHT) * SINGLE_WIDTH,
    );

    return (
        <YStack justifyContent="center">
            {physicalCard != null && virtualCard != null ? (
                <View>
                    {physicalCard != null && (
                        <FruitfulCardIcon
                            form={CardForm.PHYSICAL}
                            width={STACKED_WIDTH}
                            height={STACKED_HEIGHT}
                        />
                    )}
                    {virtualCard != null && (
                        <View marginLeft={14} marginTop={-STACK_OVERLAP}>
                            <FruitfulCardIcon
                                form={virtualCard.form}
                                color={virtualCard.color}
                                width={STACKED_WIDTH}
                                height={STACKED_HEIGHT}
                                zIndex={1}
                            />
                        </View>
                    )}
                </View>
            ) : virtualCard != null ? (
                <FruitfulCardIcon
                    form={virtualCard?.form}
                    color={virtualCard.color}
                />
            ) : (
                <FruitfulCardIcon form={CardForm.PHYSICAL} />
            )}
        </YStack>
    );
};

export default CardStack;
